import {Component} from 'preact';
import {connect} from 'preact-redux';
import _ from 'lodash'
import style from './style.scss';

import SystemModel from '/chat/src/redux/model/system/model';
import FeaturesModel from '/chat/src/redux/model/features/model';
import CustomizationModel from '/chat/src/redux/model/customization/model';

import Question from '../CategoryQuestions/Question/Question'

class SearchResults extends Component {
    __filterResults(question, searchWords) {
        for (let i = 0; i < searchWords.length; i++) {
            if (!question.includes(searchWords[i])) return false;
        }
        return true;
    }

    _search() {
        const { questions, searchInput } = this.props;
        const searchWords = searchInput.trim().toLowerCase().split(' ')
        const results = _.filter(questions, question =>  this.__filterResults(question['question'].toLowerCase(), searchWords))
        return results
    }

    _onQuestionClick(id) {
        this.props.dispatch(SystemModel.setHelpDeskRoute('HelpDeskArticle', this.props.activeCategory, id));
    }

    _renderResults() {
        const results = this._search();
        if (results.length > 0) {
            return (
                <div>
                    {results.map(question => {
                        return <Question questionTitle={question['question']} onClick={() => this._onQuestionClick(question['id'])} />
                    })}
                </div>
            )
        } else {
            return (
                <div className={style.NoResults}>
                    <div>{this.props.language.get('NoHelpDeskSearchResults')}</div>
                    <div className={style.NoResultsSearchTerm}> {this.props.searchInput} </div>
                </div>
            )
        }
    }

    render() {
        return (
            <div style={{height: `${this.props.height}px`}} className={style.SearchResultsContainer}>
                {this._renderResults()}
            </div>
        )
    }
}

function mapStatetoProps(state) {
    const searchInput = SystemModel.getSearchInput(state);
    const questions = FeaturesModel.getFeaturePayload(state, 'helpdesk')['questions'];
    const language = CustomizationModel.getLanguage(state);
    return {
        height: SystemModel.getBodyHeight(state),
        searchInput: searchInput,
        questions: questions,
        language: language
    }
}

export default connect(mapStatetoProps)(SearchResults);



// WEBPACK FOOTER //
// ./routes/HelpDesk/SearchResults/SearchResults.js